<div #cyContainer id="cy-instantiated" class="cy-map-container"></div>